import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-200 pt-16 pb-8 print:hidden min-h-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-serif text-emerald-400 font-bold">
              Mathla'un Nawakartika
            </h3>
            <p className="text-sm leading-relaxed text-slate-300">
              Membangun generasi Islami yang cerdas, mandiri, dan berakhlak mulia melalui pendidikan
              terintegrasi dan berkualitas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-emerald-400 transition-colors">
                  Tentang Kami
                </Link>
              </li>
              <li>
                <Link to="/spmb" className="hover:text-emerald-400 transition-colors">
                  Admission Info (SPMB)
                </Link>
              </li>
              <li>
                <Link to="/scholarships" className="hover:text-emerald-400 transition-colors">
                  Scholarship Programs
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-emerald-400 transition-colors">
                  Student Dashboard
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-emerald-400 transition-colors">
                  FAQ / Bantuan
                </Link>
              </li>
              <li>
                <Link to="/career" className="hover:text-emerald-400 transition-colors">
                  Karir & Lowongan
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">
              Contact Us
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-emerald-500 shrink-0 mt-0.5" />
                <span>Kp. Parigi, Pasireurih, Kec. Cisata, Kabupaten Pandeglang, Banten 42273</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-emerald-500 shrink-0" />
                <span>+62 882-2604-3174</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-emerald-500 shrink-0" />
                <span>info@manawa.sch.id</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">
              Follow Us
            </h4>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/nawakartikaofficial09/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-full hover:bg-emerald-600 transition-colors"
                aria-label="Facebook YPI Mathla'un Nawakartika"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/nawakartika_official/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-full hover:bg-emerald-600 transition-colors"
                aria-label="Instagram YPI Mathla'un Nawakartika"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="http://youtube.com/c/NawakartikaOfficial"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-full hover:bg-emerald-600 transition-colors"
                aria-label="YouTube YPI Mathla'un Nawakartika"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-300">
          <p>
            &copy; {new Date().getFullYear()} Yayasan Pendidikan Islam Mathla'un Nawakartika. All
            rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/terms" className="hover:text-emerald-400 transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-emerald-400 transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
